import { ActionMenu, BulkBar as SelectionBar, type MenuAction } from '@platform/design-system';
import { usePageContext } from '../../usePageContext.ts';

export type BulkBarProps = {
  count: number;
  actions: readonly MenuAction[];
  onClear: () => void;
};

export const BulkBar = ({ count, actions, onClear }: BulkBarProps) => {
  const { t } = usePageContext();
  return (
    <SelectionBar
      label={t('productList.bulkActions')}
      countLabel={t('productList.selected', { count })}
      clearLabel={t('productList.clearSelection')}
      onClear={onClear}
    >
      <ActionMenu label={t('catalog.actions')} text={t('catalog.actions')} actions={actions} />
    </SelectionBar>
  );
};
